import { useMemo } from "react";

// Data Layer hook para extraer datos del mensaje tipo lista
function useListMessageData(message) {
  return useMemo(() => {
    const messageText = message?.messageText || '';
    const options = message?.optionsList?.items?.[0]?.options || [];
    const optionTitle = message?.optionsList?.globalButtons?.[0]?.title || '';
    const listTitle = message?.optionsList?.title || '';
    return { messageText, options, optionTitle, listTitle };
  }, [message]);
}

export default useListMessageData;